export const loading = (state) => state.loading;
export const loadingEventos = (state) => state.loadingEventos;
export const loadingSuppression = (state) => state.loadingSuppression;
export const emails = (state) => state.emails;
export const suppressions = (state) => state.suppressions;
export const email = (state) => state.emails;
export const eventos = (state) => state.eventos;
export const page = (state) => state.page;
export const pages = (state) => state.pages;
export const itemsPerPage = (state) => state.itemsPerPage;
export const getFilters = (state) => state.filters;

export const suppressionsPage = (state) => state.suppressionsPage;
export const suppressionsPages = (state) => state.suppressionsPages;
export const suppressionsItemsPerPage = (state) => state.suppressionsItemsPerPage;
